import {
  DASH_LABELS,
  DASH_TYPES,
  OVLHP,
  OVCPL,
  DASH_TYPE_GROUPS,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  OVLHP: {
    label: DASH_LABELS.UPPER_PANEL_LEFT,
    partOverride: 'M2_OVLHP',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  OVLH6: {
    label: DASH_LABELS.UPPER_PANEL_RIGHT,
    partOverride: 'M2_OVLHP',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  OVCPL: {
    label: DASH_LABELS.UPPER_PANEL_CENTER,
    partOverride: 'M2_OVCPL',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  OVC12: {
    label: DASH_LABELS.UPPER_PANEL_CENTER,
    partOverride: 'M2_OVCPL',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.OVERHEAD_35M_007,
  type: DASH_TYPE_GROUPS.OVERHEAD,
  panels: [OVLHP, OVCPL],
  width: 1700,
  height: 200,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  C: 'Switch',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    OVLHP: {
      id: OVLHP,
      label: DASH_LABELS.UPPER_PANEL_LEFT,
      groups: {
        OVLHP: {
          id: OVLHP,
          panel: OVLHP,
          isMsfOrMst: true,
          parent: [OVLHP],
          label: 'Switches',
          detail: ['C'],
        },
      },
    },
    OVCPL: {
      id: OVCPL,
      label: DASH_LABELS.UPPER_PANEL_CENTER,
      groups: {
        OVCPL: {
          id: OVCPL,
          panel: OVCPL,
          isMsfOrMst: true,
          parent: ['OVC12', OVCPL],
          label: 'Switches',
          detail: ['C'],
        },
      },
    },
  },
}
